import { Component, OnInit } from '@angular/core';
// Vendor
import { FormUtils } from 'novo-elements';
import { TranslateService } from 'chomsky-ng2';
// App
import { ConsentService } from './consent';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  loading: boolean;
  options: any[];
  fieldsets: any;
  consentForm: any;
  view: string;
  consentPreferencesFormHeader: string;

  constructor(private consentService: ConsentService, private formUtils: FormUtils) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.consentService.getFormOptions().subscribe((data: any) => {
      this.loading = false;
      if (data.expired) {
        this.view = 'expired';
      } else {
        this.view = 'form';
        this.options = this.getOptions(data.data);
        this.consentPreferencesFormHeader = data.consentPreferencesFormHeader;
        this.setup();
      }
    });
  }

  setup() {
    const fields = this.formatMeta(this.options);
    this.fieldsets = this.formUtils.toFieldSets({ fields }, '$ USD', {}, {});
    this.consentForm = this.formUtils.toFormGroupFromFieldset(this.fieldsets);
  }

  getOptions(data) {
    if (data.fields && data.fields.length > 0) {
      return data.fields[0].options;
    }
  }

  formatMeta(options: any[]) {
    const fields: any[] = [];
    this.options.map((option, index) => {
      const optionMeta = {
        name: option.value,
        type: 'tiles',
        dataType: 'Boolean',
        required: false,
        label: option.label,
        options: [
          {
              value: true,
              label: TranslateService.translate('CONSENT.YES')
          },
          {
              value: false,
              label: TranslateService.translate('CONSENT.NO')
          }
        ],
        sortOrder: index
      };
      fields.push(optionMeta);
    });
    return fields;
  }

  save(): void {
    this.consentService.save(this.consentForm.value).subscribe((response: any) => {
      this.view = 'submitSuccess';
    }, (error: any) => {
      this.view = 'submitError';
    });
  }

}



// WEBPACK FOOTER //
// /home/jenkins/hydrogen/workspace/Release_Engineering/Artifactory-Release-Packagers/Builders/Conduit-Release/consent/src/app/app.component.ts